import { DatePipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxCpfCnpjModule } from 'ngx-cpf-cnpj';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMatDateFnsDateModule } from 'ngx-mat-datefns-date-adapter';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AgendaMedicaListComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-list/agenda-medica-list.component';
import { AbastractAssociacao } from './com/copeagenda/view/associacoes/abstract.associacao';
import { AssociacaoFilialEspecialidadeComponent } from './com/copeagenda/view/associacoes/associacao-filial-especialidade/associacao-filial-especialidade.component';
import { AssociacaoFilialMedicoComponent } from './com/copeagenda/view/associacoes/associacao-filial-medico/associacao-filial-medico.component';
import { AssociacaoMedicoPlanoSaudeComponent } from './com/copeagenda/view/associacoes/associacao-medico-plano-saude/associacao-medico-plano-saude.component';
import { AssociacaoPlanoSaudeProcedimentoComponent } from './com/copeagenda/view/associacoes/associacao-plano-saude-procedimento/associacao-plano-saude-procedimento.component';
import { AtendimentoConsultaListComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/atendimento-consulta-list/atendimento-consulta-list.component';
import { InformacaoCancelamentoCreateComponent } from './com/copeagenda/view/atendimento/informacao-cancelamento-create/informacao-cancelamento-create.component';
import { ConfirmationDialogComponent } from './com/copeagenda/view/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from './com/copeagenda/view/dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from './com/copeagenda/view/dialogs/info-dialog/info-dialog.component';
import { LoadingDialogComponent } from './com/copeagenda/view/dialogs/loading-dialog/loading-dialog.component';
import { LoadingDialogService } from './com/copeagenda/view/dialogs/loading-dialog/loading-dialog.service';
import { PhoneMaskDirective } from './com/copeagenda/view/directives/phone-mask.directive';
import { EspecialidadeListComponent } from './com/copeagenda/view/especialidade/especialidade-list/especialidade-list.component';
import { EspecialidadeMaintenanceComponent } from './com/copeagenda/view/especialidade/especialidade-maintenance/especialidade-maintenance.component';
import { FaltaMedicaListComponent } from './com/copeagenda/view/falta-medica/falta-medica-list/falta-medica-list.component';
import { FaltaMedicaMaintenanceComponent } from './com/copeagenda/view/falta-medica/falta-medica-maintenance/falta-medica-maintenance.component';
import { FeriadoListComponent } from './com/copeagenda/view/feriado/feriado-list/feriado-list.component';
import { FeriadoMaintenanceComponent } from './com/copeagenda/view/feriado/feriado-maintenance/feriado-maintenance.component';
import { FilialListComponent } from './com/copeagenda/view/filial/filial-list/filial-list.component';
import { FilialMaintenanceComponent } from './com/copeagenda/view/filial/filial-maintenance/filial-maintenance.component';
import { HistoricoEventoListComponent } from './com/copeagenda/view/historico-evento/historico-evento-list/historico-evento-list.component';
import { CacheInterceptor } from './com/copeagenda/view/interceptors/cache.interceptor';
import { ErrorInterceptor } from './com/copeagenda/view/interceptors/error.interceptor';
import { LoadingDialogInterceptor } from './com/copeagenda/view/interceptors/loading-dialog.interceptor';
import { TokenInterceptor } from './com/copeagenda/view/interceptors/token.interceptor';
import { LoginComponent } from './com/copeagenda/view/login/login.component';
import { CadastroDependenteComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/cadastro-dependente/cadastro-dependente.component';
import { CadastroPacienteComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/cadastro-paciente.component';
import { EnviarComprovanteEmailComponent } from './com/copeagenda/view/marcacao/enviar-comprovante-email/enviar-comprovante-email.component';
import { EnviarComprovanteSmsComponent } from './com/copeagenda/view/marcacao/enviar-comprovante-sms/enviar-comprovante-sms.component';
import { MarcacaoConsultaRealizadaComponent } from './com/copeagenda/view/marcacao/marcacao-consulta-realizada/marcacao-consulta-realizada.component';
import { MarcacaoConsultaComponent } from './com/copeagenda/view/marcacao/marcacao-consulta/marcacao-consulta.component';
import { MarcacaoProcedimentoRealizadoComponent } from './com/copeagenda/view/marcacao/marcacao-procedimento-realizado/marcacao-procedimento-realizado.component';
import { SelecaoConsultaComponent } from './com/copeagenda/view/marcacao/selecao-consulta/selecao-consulta.component';
import { SelecaoPacienteComponent } from './com/copeagenda/view/marcacao/selecao-paciente/selecao-paciente.component';
import { SelecaoProcedimentoComponent } from './com/copeagenda/view/marcacao/selecao-procedimento/selecao-procedimento.component';
import { MedicoListComponent } from './com/copeagenda/view/medico/medico-list/medico-list.component';
import { MedicoMaintenanceComponent } from './com/copeagenda/view/medico/medico-maintenance/medico-maintenance.component';
import { MotivoCancelamentoListComponent } from './com/copeagenda/view/motivo-cancelamento/motivo-cancelamento-list/motivo-cancelamento-list.component';
import { MotivoCancelamentoMaintenanceComponent } from './com/copeagenda/view/motivo-cancelamento/motivo-cancelamento-maintenance/motivo-cancelamento-maintenance.component';
import { BotaoVoltarComponent } from './com/copeagenda/view/navigation/botao-voltar/botao-voltar.component';
import { CustomMaterialModule } from './com/copeagenda/view/navigation/custom-nav-bar/custom-material-module';
import { CustomNavBarComponent } from './com/copeagenda/view/navigation/custom-nav-bar/custom-nav-bar.component';
import { NotificacaoCancelamentoCreateComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-create/notificacao-cancelamento-create.component';
import { NotificacaoCancelamentoDetailComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-detail/notificacao-cancelamento-detail.component';
import { NotificacaoCancelamentoListComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-list/notificacao-cancelamento-list.component';
import { CadastroDependentePeloAdminComponent } from './com/copeagenda/view/paciente/dependente/cadastro-dependente-pelo-admin/cadastro-dependente-pelo-admin.component';
import { DependenteListComponent } from './com/copeagenda/view/paciente/dependente/dependente-list/dependente-list.component';
import { DependenteMaintenanceComponent } from './com/copeagenda/view/paciente/dependente/dependente-maintenance/dependente-maintenance.component';
import { TransferenciaTitularMaintenanceComponent } from './com/copeagenda/view/paciente/dependente/transferencia-titular-maintenance/transferencia-titular-maintenance.component';
import { PacienteListComponent } from './com/copeagenda/view/paciente/paciente-list/paciente-list.component';
import { PacienteMaintenanceComponent } from './com/copeagenda/view/paciente/paciente-maintenance/paciente-maintenance.component';
import { PaginaInicialComponent } from './com/copeagenda/view/pagina-inicial/pagina-inicial.component';
import { RedefinirSenhaComponent } from './com/copeagenda/view/perfil/redefinir-senha/redefinir-senha.component';
import { HoraFormatadaPipe } from './com/copeagenda/view/pipes/hora-formatada-pipe';
import { IndTitularPipe } from './com/copeagenda/view/pipes/ind-titular-pipe';
import { MoedaFormatadaGenericaPipe } from './com/copeagenda/view/pipes/moeda-formatada-generica-pipe';
import { MoedaFormatadaPipe } from './com/copeagenda/view/pipes/moeda-formatada-pipe';
import { MoedaFormatadaProcedimentoPipe } from './com/copeagenda/view/pipes/moeda-formatada-procedimento-pipe';
import { SimNaoPipe } from './com/copeagenda/view/pipes/sim-nao-pipe';
import { TipoAgendamentoPipe } from './com/copeagenda/view/pipes/tipo-agendamento-pipe';
import { PlanoSaudeListComponent } from './com/copeagenda/view/plano-saude/plano-saude-list/plano-saude-list.component';
import { PlanoSaudeMaintenanceComponent } from './com/copeagenda/view/plano-saude/plano-saude-maintenance/plano-saude-maintenance.component';
import { ProcedimentoConsultaListComponent } from './com/copeagenda/view/procedimento/procedimento-consulta/procedimento-consulta-list/procedimento-consulta-list.component';
import { ProcedimentoConsultaMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-consulta/procedimento-consulta-maintenance/procedimento-consulta-maintenance.component';
import { RelDisponibilidadeVagasConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-disponibilidade-vagas/rel-disponibilidade-vagas-consulta.component';
import { RelMarcacaoInternaConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-marcacao-interna/rel-marcacao-interna-consulta/rel-marcacao-interna-consulta.component';
import { RelMarcacaoConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-marcacao/rel-marcacao-consulta/rel-marcacao-consulta.component';
import { RelDisponibilidadeVagasProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-disponibilidade-vagas/rel-disponibilidade-vagas-procedimento/rel-disponibilidade-vagas-procedimento.component';
import { RelMarcacaoInternaProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-marcacao-interna/rel-marcacao-interna-procedimento/rel-marcacao-interna-procedimento.component';
import { RelMarcacaoProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-marcacao/rel-marcacao-procedimento/rel-marcacao-procedimento.component';
import { UsuarioListComponent } from './com/copeagenda/view/usuario/usuario-list/usuario-list.component';
import { UsuarioMaintenanceComponent } from './com/copeagenda/view/usuario/usuario-maintenance/usuario-maintenance.component';
import { AtendimentoConsultaDetailComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/atendimento-consulta-detail/atendimento-consulta-detail.component';
import { AtendimentoProcedimentoListComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/atendimento-procedimento-list/atendimento-procedimento-list.component';
import { InformacaoFechamentoDetailComponent } from './com/copeagenda/view/atendimento/informacao-fechamento-detail/informacao-fechamento-detail.component';
import { InformacaoCancelamentoDetailComponent } from './com/copeagenda/view/atendimento/informacao-cancelamento-detail/informacao-cancelamento-detail.component';
import { AtendimentoProcedimentoDetailComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/atendimento-procedimento-detail/atendimento-procedimento-detail.component';
import { LocalizarAtendimentoConsultaListComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/localizar-atendimento-consulta-list/localizar-atendimento-consulta-list.component';
import { LocalizarAtendimentoProcedimentoListComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/localizar-atendimento-procedimento-list/localizar-atendimento-procedimento-list.component';
import { DiaSemanaPipe } from './com/copeagenda/view/pipes/dia-semana-pipe';
import { AgendaMedicaHorarioIndividualMaintenanceComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-horario-individual-maintenance/agenda-medica-horario-individual-maintenance.component';
import { AgendaMedicaMaintenanceComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-maintenance/agenda-medica-maintenance.component';
import { ProcedimentoListComponent } from './com/copeagenda/view/procedimento/procedimento-list/procedimento-list.component';
import { ProcedimentoMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-maintenance/procedimento-maintenance.component';
import { CadastroConflitoComponent } from './com/copeagenda/view/procedimento/conflito/cadastro-conflito/cadastro-conflito.component';
import { ProcedimentoAgendaMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/procedimento-agenda-maintenance/procedimento-agenda-maintenance.component';
import { ProcedimentoAgendaListComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/procedimento-agenda-list/procedimento-agenda-list.component';
import { CadastroTomadaComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/tomadas/cadastro-tomada/cadastro-tomada.component';
import { EnvioComprovanteListComponent } from './com/copeagenda/view/notificacoes/envio-comprovante/envio-comprovante-list/envio-comprovante-list.component';
import { SucessoFalhaPipe } from './com/copeagenda/view/pipes/sucesso-falha-pipe';
import { ProcurarPacienteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/procurar-paciente/procurar-paciente.component';
import { SelecionarMarcacaoConsultaParaReenvioComprovanteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/selecionar-marcacao-consulta-para-reenvio-comprovante/selecionar-marcacao-consulta-para-reenvio-comprovante.component';
import { SelecionarMarcacaoProcedimentoParaReenvioComprovanteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/selecionar-marcacao-procedimento-para-reenvio-comprovante/selecionar-marcacao-procedimento-para-reenvio-comprovante.component';
import { UnidadesListComponent } from './com/copeagenda/view/unidades/unidades-list/unidades-list.component';
import { PropagandaDialogComponent } from './com/copeagenda/view/dialogs/propaganda-dialog/propaganda-dialog.component';
import { AgendamentoPacienteListComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/agendamento-paciente-list/agendamento-paciente-list.component';
import { RelMarcacaoInternaGlobalComponent } from './com/copeagenda/view/relatorio/global/rel-marcacao-interna/rel-marcacao-interna-global/rel-marcacao-interna-global.component';
import { SelecaoAgendamentoComponent } from './com/copeagenda/view/marcacao/selecao-agendamento/selecao-agendamento.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    EspecialidadeMaintenanceComponent,
    EspecialidadeListComponent,
    CustomNavBarComponent,
    BotaoVoltarComponent,
    CadastroPacienteComponent,
    ConfirmationDialogComponent,
    LoadingDialogComponent,
    ErrorDialogComponent,
    MarcacaoConsultaComponent,
    CadastroDependenteComponent,
    PaginaInicialComponent,
    SelecaoPacienteComponent,
    SelecaoConsultaComponent,
    MarcacaoConsultaRealizadaComponent,
    EnviarComprovanteEmailComponent,
    InfoDialogComponent,
    EnviarComprovanteSmsComponent,
    SelecaoProcedimentoComponent,
    SelecaoAgendamentoComponent,
    MarcacaoProcedimentoRealizadoComponent,
    LoginComponent,
    MedicoListComponent,
    MedicoMaintenanceComponent,
    PhoneMaskDirective,
    ProcedimentoConsultaListComponent,
    ProcedimentoConsultaMaintenanceComponent,
    TipoAgendamentoPipe,
    HoraFormatadaPipe,
    MoedaFormatadaPipe,
    MoedaFormatadaProcedimentoPipe,
    MoedaFormatadaGenericaPipe,
    DiaSemanaPipe,
    IndTitularPipe,
    SimNaoPipe,
    SucessoFalhaPipe,
    UsuarioListComponent,
    UsuarioMaintenanceComponent,
    FilialListComponent,
    FilialMaintenanceComponent,
    PlanoSaudeListComponent,
    PlanoSaudeMaintenanceComponent,
    RedefinirSenhaComponent,
    AssociacaoFilialMedicoComponent,
    AbastractAssociacao,
    AssociacaoFilialEspecialidadeComponent,
    AssociacaoMedicoPlanoSaudeComponent,
    AssociacaoPlanoSaudeProcedimentoComponent,
    FaltaMedicaListComponent,
    FaltaMedicaMaintenanceComponent,
    FeriadoListComponent,
    FeriadoMaintenanceComponent,
    MotivoCancelamentoListComponent,
    MotivoCancelamentoMaintenanceComponent,
    PacienteListComponent,
    PacienteMaintenanceComponent,
    CadastroDependentePeloAdminComponent,
    DependenteListComponent,
    DependenteMaintenanceComponent,
    TransferenciaTitularMaintenanceComponent,
    HistoricoEventoListComponent,
    RelDisponibilidadeVagasConsultaComponent,
    RelMarcacaoInternaConsultaComponent,
    RelMarcacaoConsultaComponent,
    RelDisponibilidadeVagasProcedimentoComponent,
    RelMarcacaoInternaProcedimentoComponent,
    RelMarcacaoProcedimentoComponent,
    NotificacaoCancelamentoListComponent,
    NotificacaoCancelamentoDetailComponent,
    NotificacaoCancelamentoCreateComponent,
    AgendaMedicaListComponent,
    AtendimentoConsultaListComponent,
    InformacaoFechamentoDetailComponent,
    InformacaoCancelamentoCreateComponent,
    InformacaoCancelamentoDetailComponent,
    AtendimentoConsultaDetailComponent,
    AtendimentoProcedimentoListComponent,
    AtendimentoProcedimentoDetailComponent,
    LocalizarAtendimentoConsultaListComponent,
    LocalizarAtendimentoProcedimentoListComponent,
    AgendaMedicaHorarioIndividualMaintenanceComponent,
    AgendaMedicaMaintenanceComponent,
    ProcedimentoListComponent,
    ProcedimentoMaintenanceComponent,
    CadastroConflitoComponent,
    ProcedimentoAgendaMaintenanceComponent,
    ProcedimentoAgendaListComponent,
    CadastroTomadaComponent,
    EnvioComprovanteListComponent,
    ProcurarPacienteComponent,
    SelecionarMarcacaoConsultaParaReenvioComprovanteComponent,
    SelecionarMarcacaoProcedimentoParaReenvioComprovanteComponent,
    UnidadesListComponent,
    PropagandaDialogComponent,
    AgendamentoPacienteListComponent,
    RelMarcacaoInternaGlobalComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    NgxTrimDirectiveModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxCpfCnpjModule,
    NgxUpperCaseDirectiveModule,
    NgxMaskModule.forRoot(),
    MatFormFieldModule,
    NgxCurrencyModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatDateFnsDateModule,
  ],
  providers: [
    Title,
    LoadingDialogService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingDialogInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MoedaFormatadaGenericaPipe },
    { provide: TipoAgendamentoPipe },
    { provide: IndTitularPipe },
    { provide: SimNaoPipe },
    { provide: SucessoFalhaPipe },
    {
      provide: MAT_DATE_LOCALE, useValue: 'pt',
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
